/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { CloseIncidenceDto } from '../models';
import { CreateFormOptionsDto } from '../models';
import { CreateIncidenceDTO } from '../models';
import { IncidenceDetailsDto } from '../models';
import { IncidenceTableDto } from '../models';
/**
 * IncidenceApi - axios parameter creator
 * @export
 */
export const IncidenceApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Asociar órdenes de mantenimiento a una incidencia
     * @param {Array<string>} body Identificadores de las órdenes de mantenimiento
     * @param {string} id Incidence ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incidenceControllerAssignMaintenanceOrders: async (
      body: Array<string>,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling incidenceControllerAssignMaintenanceOrders.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling incidenceControllerAssignMaintenanceOrders.'
        );
      }
      const localVarPath = `/incidence/{id}/maintenance-orders`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Close RPS incidence
     * @param {CloseIncidenceDto} body
     * @param {string} id Incidence ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incidenceControllerCloseIncidence: async (
      body: CloseIncidenceDto,
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling incidenceControllerCloseIncidence.'
        );
      }
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling incidenceControllerCloseIncidence.'
        );
      }
      const localVarPath = `/incidence/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create an incidence
     * @param {CreateIncidenceDTO} body Incidence data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incidenceControllerCreateIncidence: async (
      body: CreateIncidenceDTO,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling incidenceControllerCreateIncidence.'
        );
      }
      const localVarPath = `/incidence`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all options required to create an incidence from RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incidenceControllerGetAllCreateFormOptions: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/incidence/create-options`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all incidences
     * @param {string} [status] Filtro por estado de la incidencia. Si no se indica, se devuelven todas.
     * @param {string} [date_from] Fecha inicial para filtrar incidencias por EntryDate en RPS
     * @param {string} [date_to] Fecha final para filtrar incidencias por EntryDate en RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incidenceControllerGetAllIncidences: async (
      status?: string,
      date_from?: string,
      date_to?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/incidence`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status;
      }

      if (date_from !== undefined) {
        localVarQueryParameter['dateFrom'] = date_from;
      }

      if (date_to !== undefined) {
        localVarQueryParameter['dateTo'] = date_to;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Obtener detalle completo de incidencia RPS
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incidenceControllerGetIncidenceDetailsById: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling incidenceControllerGetIncidenceDetailsById.'
        );
      }
      const localVarPath = `/incidence/detail/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all incidences associated with a maintenance order
     * @param {string} maintenance_order_id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    incidenceControllerGetIncidencesByMaintenanceOrder: async (
      maintenance_order_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'maintenance_order_id' is not null or undefined
      if (maintenance_order_id === null || maintenance_order_id === undefined) {
        throw new RequiredError(
          'maintenance_order_id',
          'Required parameter maintenance_order_id was null or undefined when calling incidenceControllerGetIncidencesByMaintenanceOrder.'
        );
      }
      const localVarPath =
        `/incidence/maintenance-order/{maintenanceOrderId}`.replace(
          `{${'maintenanceOrderId'}}`,
          encodeURIComponent(String(maintenance_order_id))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * IncidenceApi - functional programming interface
 * @export
 */
export const IncidenceApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Asociar órdenes de mantenimiento a una incidencia
     * @param {Array<string>} body Identificadores de las órdenes de mantenimiento
     * @param {string} id Incidence ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerAssignMaintenanceOrders(
      body: Array<string>,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await IncidenceApiAxiosParamCreator(
        configuration
      ).incidenceControllerAssignMaintenanceOrders(body, id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Close RPS incidence
     * @param {CloseIncidenceDto} body
     * @param {string} id Incidence ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerCloseIncidence(
      body: CloseIncidenceDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await IncidenceApiAxiosParamCreator(
        configuration
      ).incidenceControllerCloseIncidence(body, id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Create an incidence
     * @param {CreateIncidenceDTO} body Incidence data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerCreateIncidence(
      body: CreateIncidenceDTO,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<IncidenceTableDto>>
    > {
      const localVarAxiosArgs = await IncidenceApiAxiosParamCreator(
        configuration
      ).incidenceControllerCreateIncidence(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all options required to create an incidence from RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerGetAllCreateFormOptions(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<CreateFormOptionsDto>>
    > {
      const localVarAxiosArgs =
        await IncidenceApiAxiosParamCreator(
          configuration
        ).incidenceControllerGetAllCreateFormOptions(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all incidences
     * @param {string} [status] Filtro por estado de la incidencia. Si no se indica, se devuelven todas.
     * @param {string} [date_from] Fecha inicial para filtrar incidencias por EntryDate en RPS
     * @param {string} [date_to] Fecha final para filtrar incidencias por EntryDate en RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerGetAllIncidences(
      status?: string,
      date_from?: string,
      date_to?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<IncidenceTableDto>>>
    > {
      const localVarAxiosArgs = await IncidenceApiAxiosParamCreator(
        configuration
      ).incidenceControllerGetAllIncidences(
        status,
        date_from,
        date_to,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Obtener detalle completo de incidencia RPS
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerGetIncidenceDetailsById(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<IncidenceDetailsDto>>
    > {
      const localVarAxiosArgs = await IncidenceApiAxiosParamCreator(
        configuration
      ).incidenceControllerGetIncidenceDetailsById(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Get all incidences associated with a maintenance order
     * @param {string} maintenance_order_id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerGetIncidencesByMaintenanceOrder(
      maintenance_order_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<IncidenceTableDto>>>
    > {
      const localVarAxiosArgs = await IncidenceApiAxiosParamCreator(
        configuration
      ).incidenceControllerGetIncidencesByMaintenanceOrder(
        maintenance_order_id,
        options
      );
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * IncidenceApi - factory interface
 * @export
 */
export const IncidenceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Asociar órdenes de mantenimiento a una incidencia
     * @param {Array<string>} body Identificadores de las órdenes de mantenimiento
     * @param {string} id Incidence ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerAssignMaintenanceOrders(
      body: Array<string>,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return IncidenceApiFp(configuration)
        .incidenceControllerAssignMaintenanceOrders(body, id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Close RPS incidence
     * @param {CloseIncidenceDto} body
     * @param {string} id Incidence ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerCloseIncidence(
      body: CloseIncidenceDto,
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return IncidenceApiFp(configuration)
        .incidenceControllerCloseIncidence(body, id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create an incidence
     * @param {CreateIncidenceDTO} body Incidence data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerCreateIncidence(
      body: CreateIncidenceDTO,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<IncidenceTableDto>> {
      return IncidenceApiFp(configuration)
        .incidenceControllerCreateIncidence(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all options required to create an incidence from RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerGetAllCreateFormOptions(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<CreateFormOptionsDto>> {
      return IncidenceApiFp(configuration)
        .incidenceControllerGetAllCreateFormOptions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all incidences
     * @param {string} [status] Filtro por estado de la incidencia. Si no se indica, se devuelven todas.
     * @param {string} [date_from] Fecha inicial para filtrar incidencias por EntryDate en RPS
     * @param {string} [date_to] Fecha final para filtrar incidencias por EntryDate en RPS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerGetAllIncidences(
      status?: string,
      date_from?: string,
      date_to?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<IncidenceTableDto>>> {
      return IncidenceApiFp(configuration)
        .incidenceControllerGetAllIncidences(
          status,
          date_from,
          date_to,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Obtener detalle completo de incidencia RPS
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerGetIncidenceDetailsById(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<IncidenceDetailsDto>> {
      return IncidenceApiFp(configuration)
        .incidenceControllerGetIncidenceDetailsById(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all incidences associated with a maintenance order
     * @param {string} maintenance_order_id Maintenance order UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async incidenceControllerGetIncidencesByMaintenanceOrder(
      maintenance_order_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<IncidenceTableDto>>> {
      return IncidenceApiFp(configuration)
        .incidenceControllerGetIncidencesByMaintenanceOrder(
          maintenance_order_id,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * IncidenceApi - object-oriented interface
 * @export
 * @class IncidenceApi
 * @extends {BaseAPI}
 */
export class IncidenceApi extends BaseAPI {
  /**
   *
   * @summary Asociar órdenes de mantenimiento a una incidencia
   * @param {Array<string>} body Identificadores de las órdenes de mantenimiento
   * @param {string} id Incidence ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IncidenceApi
   */
  public async incidenceControllerAssignMaintenanceOrders(
    body: Array<string>,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return IncidenceApiFp(this.configuration)
      .incidenceControllerAssignMaintenanceOrders(body, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Close RPS incidence
   * @param {CloseIncidenceDto} body
   * @param {string} id Incidence ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IncidenceApi
   */
  public async incidenceControllerCloseIncidence(
    body: CloseIncidenceDto,
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return IncidenceApiFp(this.configuration)
      .incidenceControllerCloseIncidence(body, id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Create an incidence
   * @param {CreateIncidenceDTO} body Incidence data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IncidenceApi
   */
  public async incidenceControllerCreateIncidence(
    body: CreateIncidenceDTO,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<IncidenceTableDto>> {
    return IncidenceApiFp(this.configuration)
      .incidenceControllerCreateIncidence(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all options required to create an incidence from RPS
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IncidenceApi
   */
  public async incidenceControllerGetAllCreateFormOptions(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<CreateFormOptionsDto>> {
    return IncidenceApiFp(this.configuration)
      .incidenceControllerGetAllCreateFormOptions(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all incidences
   * @param {string} [status] Filtro por estado de la incidencia. Si no se indica, se devuelven todas.
   * @param {string} [date_from] Fecha inicial para filtrar incidencias por EntryDate en RPS
   * @param {string} [date_to] Fecha final para filtrar incidencias por EntryDate en RPS
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IncidenceApi
   */
  public async incidenceControllerGetAllIncidences(
    status?: string,
    date_from?: string,
    date_to?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<IncidenceTableDto>>> {
    return IncidenceApiFp(this.configuration)
      .incidenceControllerGetAllIncidences(status, date_from, date_to, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Obtener detalle completo de incidencia RPS
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IncidenceApi
   */
  public async incidenceControllerGetIncidenceDetailsById(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<IncidenceDetailsDto>> {
    return IncidenceApiFp(this.configuration)
      .incidenceControllerGetIncidenceDetailsById(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Get all incidences associated with a maintenance order
   * @param {string} maintenance_order_id Maintenance order UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IncidenceApi
   */
  public async incidenceControllerGetIncidencesByMaintenanceOrder(
    maintenance_order_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<IncidenceTableDto>>> {
    return IncidenceApiFp(this.configuration)
      .incidenceControllerGetIncidencesByMaintenanceOrder(
        maintenance_order_id,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
